export const APP_NAME = '@msdk/charybui-unknown-👻'
export const APP_VERSION = 'X.X.X'
export const APP_OTEL_APM = 'http://localhost:4318'
